import React from 'react';
import { TextColor } from '../../view-model/Colors';
import { LineHeight } from '../../view-model/LineHights';
import { FontWeight } from '../../view-model/FontWeight';
import { FontSize } from '../../view-model/FontSize';

interface TypographyProps {
  size: FontSize;
  weight: FontWeight;
  line_height: LineHeight;
  color?: TextColor;
  as?: keyof JSX.IntrinsicElements;
  className?: string;
  children: React.ReactNode;
  id?: string
}

function Typography({
  size,
  weight,
  line_height,
  color,
  as = 'div',
  className = '',
  children,
  id
}: Readonly<TypographyProps>): React.ReactElement {
  const Component = as;
  const classNames = [
    size,
    weight,
    line_height,
    color ?? '',
    className,
  ].join(" ");
  return <Component id={id} className={classNames}>{children}</Component>;
}

export default Typography;
